import { render } from "./qnaWrite.vue?vue&type=template&id=97b9cb22&scoped=true"
import script from "./qnaWrite.vue?vue&type=script&lang=js"
export * from "./qnaWrite.vue?vue&type=script&lang=js"

import "@/styles/common.css?vue&type=style&index=0&id=97b9cb22&scoped=true&lang=css"
import "@/styles/subcommon.css?vue&type=style&index=1&id=97b9cb22&scoped=true&lang=css"
import "./qnaWrite.vue?vue&type=style&index=2&id=97b9cb22&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b9cb22"]])

export default __exports__